package team.platforma.aicombo

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.ButtonDefaults
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.OutlinedTextFieldDefaults
import androidx.compose.material3.darkColorScheme
import androidx.compose.material3.lightColorScheme
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.remember
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.draw.shadow
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.dp
import androidx.navigation.compose.rememberNavController
import org.jetbrains.compose.ui.tooling.preview.Preview
import org.koin.compose.viewmodel.koinViewModel
import org.koin.core.annotation.KoinExperimentalAPI
import team.platforma.accountmanagerlib.getAccountManager
import team.platforma.aicombo.activity.auth.AuthActivity
import team.platforma.aicombo.activity.chat.ChatActivity
import team.platforma.aicombo.activity.main.MainApp
import team.platforma.aicombo.theme.colors.AppColors
import team.platforma.aicombo.theme.colors.defineColors
import team.platforma.aicombo.theme.typography.FontWeights
import team.platforma.aicombo.theme.typography.Typography
import team.platforma.chat_presentation.ChatViewModel
import team.platforma.extra_nav.navigator.activity.GlobalNavigator
import team.platforma.extra_nav.ui.style.NavigationItemStyle
import team.platforma.extra_nav.ui.style.NavigationStyle
import team.platforma.extra_nav.ui.style.SimpleNavigationStyle
import team.platforma.extra_nav.utils.Type
import team.platforma.extra_nav.utils.rememberDeviceType
import team.platforma.multiplatform_material_extension.button.style.AppButtonStyle
import team.platforma.multiplatform_material_extension.tab_row.style.AdaptiveTabRowStyle
import team.platforma.multiplatform_material_extension.tab_row.style.Tab
import team.platforma.multiplatform_material_extension.tab_row.style.TabRow
import team.platforma.multiplatform_material_extension.text_input.style.TextInput
import team.platforma.multiplatform_material_extension.toolbar.style.AppToolbarStyle
import team.platforma.multiplatform_material_extension.toolbar.style.ToolbarStyle
import team.platforma.multiplatform_material_extension.ui.theme.isDark
import team.platforma.multiplatform_material_extension.ui.theme.rememberTheme

@OptIn(KoinExperimentalAPI::class)
@Composable
@Preview
fun App() {
    koinViewModel<ChatViewModel>()


    val navHostController = rememberNavController()
    val globalNavigator = remember { GlobalNavigator(navHostController) }
    val accountManager = getAccountManager()
    //Не трогать этот лог. Он выполняет функцию синхронизации для запуска JS таргета
    println("Accs exist:${accountManager.isAccountExists()}, log in last:${accountManager.logInLastUsedAccount()}")
    val startActivity = remember {
        if (accountManager.isAccountExists()) {
            if (accountManager.logInLastUsedAccount()) {

                MainApp
            } else {
                AuthActivity
            }
        } else {
            AuthActivity
        }
    }

    val theme = rememberTheme(autoSwitch = true)
    defineColors(theme.isDark())

    SimpleNavigationStyle.define(
        navStyle = NavigationStyle(
            background = AppColors.bg.base().default,
            modifier = Modifier.shadow(
                elevation = 4.dp
            ),
            horizontalPadding = 0.dp
        ),
        navigationItemStyle = NavigationItemStyle(
            selectedLabel = AppColors.text().primary,
            defaultLabel = AppColors.text().caption,
            shape = RoundedCornerShape(8.dp),
            desktopItemWidth = 110.dp
        ),
        labelStyle = Typography.textXs(FontWeights.Regular),
        iconSize = 32.dp
    )
    val device by rememberDeviceType()

    AdaptiveTabRowStyle.define(
        tab = Tab(
            indicator = { tabPositions, selectedTabIndex, list ->
//                if (selectedTabIndex in list.indices) {
//                    BoxWithConstraints(
//                        modifier = Modifier.fillMaxHeight()
//                    ) {
//                        TabRowDefaults.SecondaryIndicator(
//                            modifier = Modifier.fillMaxHeight()
//                                .tabIndicatorOffset(tabPositions[selectedTabIndex])
//                                .zIndex(0f)
//                                .then(
//                                    Modifier.padding(8.dp).background(
//                                        color = AppColors.bg.primary().default,
//                                        shape = RoundedCornerShape(6.dp)
//                                    )
//                                ),
//                            color = Color.Transparent,
//                            height = maxHeight
//                        )
//                    }
//
//                }
            },
            defaultTabModifier = Modifier.padding(8.dp).background(
                color = AppColors.bg.base().default,
                shape = RoundedCornerShape(6.dp)
            ).clip(RoundedCornerShape(6.dp)),
            checkedTabModifier = Modifier.padding(8.dp).background(
                color = AppColors.bg.primary().default,
                shape = RoundedCornerShape(6.dp)
            ).clip(RoundedCornerShape(6.dp)),
            selectedContentColor = AppColors.text().light,
            unselectedContentColor = AppColors.text().default
        ),
        tabRow = TabRow(
            divider = {},
            edgePadding = when (device) {
                Type.MOBILE -> 8.dp
                Type.TABLET -> 40.dp
                Type.DESKTOP -> 40.dp
            },
            customTabPadding = 8.dp
        )
    )

    ToolbarStyle.define(
        toolbarStyle = AppToolbarStyle(
            containerColor = AppColors.bg.base().default,
            titleContentColor = AppColors.text().default,
            navigationIconContentColor = AppColors.text().default,
            actionIconContentColor = AppColors.text().default
        ),
        modifier = Modifier.shadow(
            elevation = 4.dp
        )
    )

    AppButtonStyle.define(
        button = AppButtonStyle.Button(
            shape = RoundedCornerShape(6.dp)
        ),
        filledButton = AppButtonStyle.Button(
            colors = ButtonDefaults.buttonColors().copy(
                containerColor = AppColors.bg.primary().default,
                contentColor = AppColors.text().light,
                disabledContainerColor = AppColors.backgroundDisable(),
                disabledContentColor = AppColors.text().disabled
            )
        ),
        textButton = AppButtonStyle.Button(
            colors = ButtonDefaults.textButtonColors().copy(
                contentColor = AppColors.text().default,
            )
        )
    )

    TextInput.define(
        style = TextInput.Style.Outline,
        colors = OutlinedTextFieldDefaults.colors().copy(
            focusedIndicatorColor = Color.Transparent,
            unfocusedIndicatorColor = Color.Transparent,
            cursorColor = AppColors.text().primary,
            focusedTextColor = AppColors.text().default,
            unfocusedTextColor = AppColors.text().default,
            focusedPlaceholderColor = AppColors.text().caption,
            unfocusedPlaceholderColor = AppColors.text().caption
        )
    )


    MaterialTheme(
        colorScheme = (if (theme.isDark()) darkColorScheme().copy(
            surface = AppColors.surface(),
            background = AppColors.bg.default().default
        ) else lightColorScheme()).copy(
            surface = AppColors.surface(),
            background = AppColors.bg.default().default
        )
    ) {

//        val keyboardHeight by rememberKeyboardHeight()

        globalNavigator.setupNavHost(
//            modifier = Modifier.imePadding(),
            activities = listOf(AuthActivity, MainApp, ChatActivity),
            startActivity = startActivity
        )
    }
}